<template>
  <div class="color__interior">
    <div v-for="(image, index) in inner_images" :key="index">
      <img :src="image" class="img1" @click="showMultiple(index)" />
      <vue-easy-lightbox
        escDisabled
        moveDisabled
        :visible="visible"
        :imgs="lightbox_images.imgs"
        :index="lightbox_index"
        @hide="handleHide"
      ></vue-easy-lightbox>
      <!-- showSingle -->
    </div>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import { props, context, inject, reactive, ref, watch } from "vue";

export default {
  props: ["inner_images"],
  components: {
    VueEasyLightbox,
  },
  setup(props) {
    let visible = ref(false);
    let lightbox_index = 0;
    let lightbox_images = reactive({ imgs: "" });
    const showMultiple = (index) => {
      if (window.matchMedia("(max-width:" + 560 + "px)").matches) {
      } else {
        visible.value = true;
        lightbox_index = index;
        lightbox_images.imgs = props.inner_images;
      }
    };
    const handleHide = () => {
      visible.value = false;
    };
    return {
      lightbox_images,
      visible,
      lightbox_index,
      showMultiple,
      handleHide,
    };
  },
};
</script>
<style scoped>
</style>